import { Box, Container, Typography } from '@mui/material';
import { PageHead } from '../../components/public/PageHead';

export function TermsPage() {
  return (
    <>
      <PageHead title="Termini e condizioni" description="Termini e condizioni d'uso del servizio Cantir." />
      <Box sx={{ py: 6, px: 2 }}>
        <Container maxWidth="md">
          <Typography variant="h4" fontWeight={700} gutterBottom>Termini e condizioni</Typography>
          <Typography color="text.secondary" sx={{ mb: 4 }}>Ultimo aggiornamento: 2026. I contenuti seguenti sono placeholder e vanno sostituiti con i testi legali definitivi.</Typography>

          <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>1. Oggetto</Typography>
          <Typography paragraph>Definizione del servizio Cantir e dell'accettazione dei presenti termini.</Typography>

          <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>2. Registrazione e account</Typography>
          <Typography paragraph>Obblighi in fase di registrazione, veridicita dei dati, responsabilità dell'utente.</Typography>

          <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>3. Utilizzo del servizio</Typography>
          <Typography paragraph>Uso lecito, divieti, proprieta intellettuale sui contenuti e sul software.</Typography>

          <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>4. Prezzi e pagamento</Typography>
          <Typography paragraph>Condizioni commerciali, fatturazione, rinnovi e recesso secondo l offerta applicabile.</Typography>

          <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>5. Limitazione di responsabilità</Typography>
          <Typography paragraph>Esclusioni e limiti di responsabilità nei limiti di legge.</Typography>

          <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>6. Modifiche e recesso</Typography>
          <Typography paragraph>Modifica dei termini, comunicazioni, diritto di recesso.</Typography>

          <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>7. Legge applicabile e foro competente</Typography>
          <Typography paragraph>Indicare legge applicabile e foro competente.</Typography>
        </Container>
      </Box>
    </>
  );
}
